import {ThreeBottomUnit} from '../ThreeBottomUnit';
import {KitchenService} from '../../../../../services/KitchenService/KitchenService';
import {ThreeBottomPilasterCorpus} from "../../../details/ThreeCorpus/types/ThreeBottomPilasterCorpus";
import {ISaveBottomUnitData} from '../../../../../../../common-code/interfaces/saveData/ISaveBottomUnitData';
import {ISaveCorpusData} from '../../../../../../../common-code/interfaces/saveData/ISaveCorpusData';
import {CommonHelper} from 'common-code';

export class ThreeBottomUnitPilaster extends ThreeBottomUnit {
    corpus: ThreeBottomPilasterCorpus;

    constructor(options: ISaveBottomUnitData, service: KitchenService) {
        super(options, service);
        this.corpus = this.initCorpus(options.corpus);
    }

    protected initCorpus(corpusData: ISaveCorpusData): ThreeBottomPilasterCorpus {
        return new ThreeBottomPilasterCorpus(CommonHelper.deepCopy(corpusData), this)
    }
}